import {ApiService, IAjaxOptions} from './ApiService';

class DownloadService {
    public async downloadFile<T>(url: string, params?: T, sourceFileName?: string, options?: IAjaxOptions) {
        const response = await ApiService.getTypedData<Buffer>(url, params, { ...options, responseType: 'blob' });

        let fileName = sourceFileName;
        if (!fileName) {
            fileName = '';
            const disposition = response.headers['content-disposition'];
            if (disposition && disposition.indexOf('attachment') !== -1) {
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                let matches = filenameRegex.exec(disposition);
                if (matches && matches[1]) {
                    fileName = matches[1].replace(/['"]/g, '');
                }
            }
        }
        await this.downloadBlob(new Blob([response.data]), fileName);
    }

    public async downloadBlob (blob: Blob, fileName: string) {
        const objectUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        await link.click();
        document.body.removeChild(link);
        window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 100);
    }
}

export const downloadService = new DownloadService();
